module.exports = __webpack_public_path__ + "static/img/图层 44.92bce0a0.png";